import {DurationInput} from 'apstra-ui-common';
import type {JSONSchema7} from 'json-schema';
import {isFinite, isNull} from 'lodash';
import {FC} from 'react';

const MINUTE_IN_SECONDS = 60;
const HOUR_IN_SECONDS = MINUTE_IN_SECONDS * 60;
const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24;

// TODO: use from apstra-ui-common when available
type DurationInputProps = {
  disabled?: boolean;
  errors?: string[];
  name?: string;
  required?: boolean;
  schema?: JSONSchema7;
  selectedValueLabel?: string;
}

type AggregationInputProps = {
  aggregations?: {text: string, value: number}[];
  customValueType?: string;
  label?: string;
  value: number;
  onChange: (value: number) => void;
} & DurationInputProps;

const AggregationInput: FC<AggregationInputProps> = ({
  aggregations = aggregationIntervalOptionsWithOff,
  customValueType = 'duration',
  label = '',
  value,
  onChange,
  ...props
}) => (
  <DurationInput
    value={isFinite(value) ? value : null}
    selectedValueLabel={label}
    textPrefix=''
    additionLabel='Aggregation: '
    placeholder='Select Aggregation'
    fluid
    durations={aggregations}
    fieldProps={{className: 'aggregation-input'}}
    onChange={(newValue) => onChange(isNull(newValue) ? value : newValue)}
    customValueType={customValueType}
    {...props}
  />
);

export const aggregationIntervalOptions: AggregationInputProps['aggregations'] = [
  {text: '5 Seconds', value: 5},
  {text: '10 Seconds', value: 10},
  {text: '30 Seconds', value: 30},
  {text: '1 Minute', value: MINUTE_IN_SECONDS},
  {text: '2 Minutes', value: MINUTE_IN_SECONDS * 2},
  {text: '5 Minutes', value: MINUTE_IN_SECONDS * 5},
  {text: '30 Minutes', value: MINUTE_IN_SECONDS * 30},
  {text: '1 Hour', value: HOUR_IN_SECONDS},
  {text: '12 Hours', value: HOUR_IN_SECONDS * 12},
  {text: '1 Day', value: DAY_IN_SECONDS},
  {text: '7 Days', value: DAY_IN_SECONDS * 7},
  {text: '30 Days', value: DAY_IN_SECONDS * 30},
];

export const aggregationIntervalOptionsWithOff: AggregationInputProps['aggregations'] = [
  {text: 'Off', value: 0},
  ...aggregationIntervalOptions
];

export default AggregationInput;
